import { getAPI } from "services/http";

export const isObjEmpty = (obj = {}) => {
  const valueArray = Object.values(obj || {});

  return valueArray.filter((el) => el).length === 0;
};

export const InputLabelStyle = {
  fontFamily: "Gilroy-Regular",
  fontSize: "12px",
  lineHeight: "14px",
  color: "#414141",
  marginTop: "10px",
  fontWeight: "500",
  marginBotton: "0",
};

export const getValueById = (list = [], id = null) => {
  const filteredValue = list.filter((el) => el.value === id);

  return filteredValue.length
    ? { label: filteredValue[0].label, value: id }
    : "";
};

export const getLabelById = (list = [], id = null) => {
  const filteredValue = list.filter((el) => el.value === id);

  return filteredValue.length ? filteredValue[0].label : "-";
};

export const getData = (url, stateMethod, keyword) => {
  getAPI(
    url,
    (data) => {
      const dropList = data.data.map((item) => {
        return { value: item.id, label: item[`${keyword}DispValue`] };
      });
      stateMethod(dropList);
    },
    (data) => {
      // failureToast(data['message']);
    }
  );
};

export const NEW_EMPTY_ROW = {
  __status: "__new",
  isNew: true,
  status: "ACTIVE",
  pincodeDesc: "",
  pincodeDispValue: "",
  effectiveDate: "",
  pincodeGstCode: "",
  salesforceId: "",
  websiteId: "",
  countryId: "",
  stateId: "",
  districtId: "",
  cityId: "",
  // createdOn: today()
};

export const AAutoCompleteCustomStyles = {
  height: "40px",

  style: {
    control: {
      borderRadius: "4px",
    },
  },
  className: "w-100",

  isShowCount: false,
  isMulti: false,
};
